import React from 'react';

import './styles.scss';

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <p>Copyright © 2023 TimeSheet.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
